import { jsx as _jsx } from "react/jsx-runtime";
import React, { useEffect, useRef } from 'react';
import { Box } from '@honda-canada/design-system-react';
import themeStyles from './Timeline.styles';
const ProgressContainer = themeStyles.apply(Box, 'ProgressContainer');
const ProgressContainerWidth = themeStyles.apply(Box, 'ProgressContainerWidth');
const YearsProgressBar = ({ progress, setRef }) => {
    const headerRef = useRef(null);
    useEffect(() => {
        setRef(headerRef.current);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    return (_jsx(ProgressContainer, { ref: headerRef, isVisible: progress !== 0, children: _jsx(ProgressContainerWidth, { width: `${progress || 0}%` }) }));
};
export default YearsProgressBar;
